import { render, staticRenderFns } from "./course_detail.vue?vue&type=template&id=22cb5bb8&scoped=true"
import script from "./course_detail.vue?vue&type=script&lang=js"
export * from "./course_detail.vue?vue&type=script&lang=js"
import style0 from "./course_detail.vue?vue&type=style&index=0&id=22cb5bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb5bb8",
  null
  
)

export default component.exports